import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';

import { TabPanel, Tab } from '../../../components';

import { getToken } from './api';
import AttributeGroups from './attribute-group';
import ProviderPractice from './provider-practice';
import ACRSUpload from './acrs-upload';
import VirtualProviders from './virtual-providers';
import ProviderStatus from './provider-status';
import Reports from './reports';
import ProviderADTStatus from './provider-adt-notifications';
import PatientList from './patient-list';

import './styles.scss';

const SettingsPage = ({ user, ...props }) => {
	const { tab } = useParams();
	const navigate = useNavigate();
	const userRaw = user.toJSON();

	const tabs = [
		<Tab key="attrgroup" id="attrgroup" title="Attribute Groups">
			<AttributeGroups {...props} user={userRaw} />
		</Tab>,
		<Tab key="patientlist" id="patientlist" title="Practice Patients">
			<PatientList {...props} user={userRaw} />
		</Tab>,
		<Tab key="providerpractice" id="providerpractice" title="Provider Practice">
			<ProviderPractice {...props} user={userRaw} />
		</Tab>,
		<Tab key="virtualproviders" id="virtualproviders" title="Virtual Providers">
			<VirtualProviders {...props} user={userRaw} />
		</Tab>,
		<Tab key="providerstatus" id="providerstatus" title="Provider Availability">
			<ProviderStatus {...props} user={userRaw} />
		</Tab>,
		<Tab key="acrsupload" id="acrsupload" title="ACRS Upload">
			<ACRSUpload
				{...props}
				user={userRaw}
				practice={userRaw.provider_practice}
			/>
		</Tab>,
		<Tab key="reports" id="reports" title="Reports">
			<Reports token={getToken()} />
		</Tab>,
	];

	const handleTabChange = (newActiveTab) => {
		navigate(`../settings/${newActiveTab}`);
	};

	if (
		userRaw.provider_practice &&
		(Boolean(userRaw.provider_practice.organization_oid) ||
			Boolean(userRaw.provider_practice.practice_oid))
	) {
		tabs.push(
			<Tab
				key="provideradtstatus"
				id="provideradtstatus"
				title="ADT Notifications"
			>
				<ProviderADTStatus {...props} user={userRaw} />
			</Tab>
		);
	}

	return (
		<div className="content-wrapper">
			<TabPanel selectedTab={tab} onTabChange={handleTabChange}>
				{tabs}
			</TabPanel>
		</div>
	);
};

SettingsPage.propTypes = {
	user: PropTypes.object,
	showNotification: PropTypes.func,
	// tab: PropTypes.string,
	// app: PropTypes.object,
};

export default SettingsPage;
